export default function loadScript(scriptSrc) {
  const scriptTag = document.createElement('script')
  scriptTag.type = 'text/javascript'
  scriptTag.async = true
  scriptTag.src = scriptSrc
  const insertBeforeElement = document.getElementsByTagName('script')[0]
  insertBeforeElement.parentNode.insertBefore(scriptTag, insertBeforeElement)
}
